import * as React from 'react'

export default function Panel() {
  return (
    <h2>I'm a Panel</h2>
  )
}
